import { oc } from '@orpc/contract';
import { z } from 'zod';
import { Email } from './common.js';
export const Profile = z.object({
    name: z.string(),
    email: Email,
    /** Валюта, в которой считаются итоги и статистика (docs/PLAN.md, раздел 2, п. 5). */
    baseCurrency: z.string().regex(/^[A-Z]{3}$/),
});
export const profileContract = {
    get: oc.route({ method: 'GET', path: '/profile' }).output(Profile),
    update: oc
        .route({ method: 'PATCH', path: '/profile' })
        .errors({ VALIDATION_FAILED: { status: 400, message: 'validation_failed' } })
        .input(z.object({
        name: z.string().trim().min(1).max(100).optional(),
        baseCurrency: z
            .string()
            .regex(/^[A-Z]{3}$/)
            .optional(),
    }))
        .output(Profile),
};
//# sourceMappingURL=profile.js.map